// 每个主题各自的导航配置——任务中心
export const taskCenterConfig = [
    {
        label: '视频任务',
        name: 'videoTaskV2',
        icon: 'video-solid'
    },
    {
        label: '图片任务',
        name: 'imageTaskV2',
        hideRole: 'digital_is_passport',
        icon: 'image-solid'
    },
    {
        label: '文案任务',
        name: 'textTaskV2',
        hideRole: 'digital_is_passport',
        icon: 'text-square-solid'
    },
    {
        label: '脚本任务',
        name: 'scriptTaskV2',
        hideRole: 'digital_is_passport',
        icon: 'file-solid'
    }
];

// 每个主题各自的导航配置——资产库
export const assetLibraryConfig = [
    {
        label: '投放库',
        icon: 'box-solid',
        children: [
            {
                label: '视频',
                name: 'assetsV2LibraryVideo'
            },
            {
                label: '图片',
                name: 'assetsV2LibraryImage'
            },
            {
                label: '文案',
                name: 'assetsV2LibraryText'
            }
        ]
    }, {
        label: '原料库',
        icon: 'folder-download-solid',
        children: [
            {
                label: '视频',
                name: 'assetsV2LibraryRawVideo'
            },
            {
                label: '图片',
                name: 'assetsV2LibraryRawImage'
            },
            {
                label: '脚本',
                name: 'assetsV2LibraryScript'
            }
        ]
    }
];

// 每个主题各自的导航配置——市场
export const marketConfig = [
    {
        label: '数字人模特',
        name: 'digitalHumanListV2',
        icon: 'smiley-star-solid'
    },
    {
        label: '智能语音',
        name: 'digitalVoiceListV2',
        icon: 'sound-wave'
    },
    {
        label: '视频模板',
        name: 'digitalVideoTemplateV2',
        icon: 'long-video-solid'
    },
    {
        label: '图片模板',
        name: 'imageTemplateV2',
        hideRole: 'digital_is_passport',
        icon: 'template-solid'
    }
];

// 每个主题各自的导航配置——发现
export const findV2Config = [
    {
        label: '生成灵感',
        icon: 'smiley-star-solid',
        children: [
            {
                label: '图片生成',
                name: 'findV2Image',
                anyMatch: {
                    allowInnerUser: true,
                    authorizedRole: ['digital_human_list']
                }
            },
            {
                label: '视频生成',
                name: 'findV2Video',
                authorizedRole: 'is_qingduo_uc_user'
            }
        ]
    },
    {
        label: '创意灵感',
        icon: 'folder-download-solid',
        children: [
            {
                label: '视频灵感',
                name: 'findV2Script',
                authorizedRole: 'qingduo_scenery_image_generate_video',
                forbidOuterUser: true
            },
            {
                label: '视频灵感',
                name: 'findV2ScriptNew',
                authorizedRole: 'qingduo_image_digital'
            }
        ]
    }
];
export const diagnoseConfig = [
    {
        label: '投后诊断',
        icon: 'trend-monitor-solid',
        forbidOuterUser: true,
        children: [
            {
                label: '单素材诊断',
                name: 'diagnoseAfterPut',
                forbidOuterUser: true,
                authorizedRole: 'digital_human_list'
            }
        ]
    }, {
        label: '投前分析',
        icon: 'shield-wave-solid',
        children: [
            {
                label: '视频预检',
                name: 'videoPreCheck',
                authorizedRole: 'is_qingduo_uc_user'
            }
        ]
    }
];
